/**
 * Curated Classic Films — 30+ questions, Hollywood golden age through ~1980.
 *
 * Bias: Casablanca, Wizard of Oz, Gone with the Wind, Hitchcock, Wilder,
 * Hepburn, Bogart, Stewart, Brando, Newman, Streisand, Eastwood, Wayne,
 * The Sound of Music, Singin\' in the Rain, West Side Story, Doctor Zhivago,
 * The Godfather, Star Wars, Jaws.
 */

import type { TriviaQuestion } from './types';

export const CURATED_CLASSIC_FILMS: TriviaQuestion[] = [
  {
    id: 'c-cf-01',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: '"Here\'s looking at you, kid" is a line from which 1942 film?',
    options: ['Citizen Kane', 'Casablanca', 'Gone with the Wind', 'The Maltese Falcon'],
    correctIndex: 1,
    blurb: 'Bogart improvised that line on set — it wasn\'t in the script.',
    source: 'curated',
  },
  {
    id: 'c-cf-02',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Who played Scarlett O\'Hara in Gone with the Wind?',
    options: ['Bette Davis', 'Vivien Leigh', 'Joan Crawford', 'Ingrid Bergman'],
    correctIndex: 1,
    blurb: 'A British actress playing the Southern belle — David Selznick hired her on a whim.',
    source: 'curated',
  },
  {
    id: 'c-cf-03',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'In The Wizard of Oz, what color were Dorothy\'s shoes in the film?',
    options: ['Silver', 'Gold', 'Ruby red', 'Emerald green'],
    correctIndex: 2,
    blurb: 'They were silver in the book — MGM made them red because it showed off Technicolor.',
    source: 'curated',
  },
  {
    id: 'c-cf-04',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Singin\' in the Rain stars which dancer-actor in the title number?',
    options: ['Fred Astaire', 'Gene Kelly', 'Donald O\'Connor', 'Bing Crosby'],
    correctIndex: 1,
    blurb: 'Gene Kelly was running a 103° fever the day they shot the title number.',
    source: 'curated',
  },
  {
    id: 'c-cf-05',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Which Hitchcock film features a famous shower scene at the Bates Motel?',
    options: ['Vertigo', 'Rear Window', 'Psycho', 'The Birds'],
    correctIndex: 2,
    blurb: 'Psycho, 1960 — that shower scene took seven days to shoot for 45 seconds of film.',
    source: 'curated',
  },
  {
    id: 'c-cf-06',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Who played Atticus Finch in To Kill a Mockingbird?',
    options: ['Cary Grant', 'James Stewart', 'Gregory Peck', 'Henry Fonda'],
    correctIndex: 2,
    blurb: 'Peck called it the role of his life — Harper Lee gave him her father\'s pocket watch.',
    source: 'curated',
  },
  {
    id: 'c-cf-07',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'The Sound of Music is set in which country?',
    options: ['Switzerland', 'Germany', 'Austria', 'Italy'],
    correctIndex: 2,
    blurb: 'The hills are in Salzburg — and the real von Trapp family did escape over them.',
    source: 'curated',
  },
  {
    id: 'c-cf-08',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Marlon Brando whispers about an offer "you can\'t refuse" in which 1972 film?',
    options: ['On the Waterfront', 'The Godfather', 'Apocalypse Now', 'A Streetcar Named Desire'],
    correctIndex: 1,
    blurb: 'Coppola almost lost the directing job a half-dozen times before that opening wedding scene.',
    source: 'curated',
  },
  {
    id: 'c-cf-09',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Audrey Hepburn has breakfast at which jeweller in the 1961 classic?',
    options: ['Cartier', 'Harry Winston', 'Tiffany', 'Van Cleef'],
    correctIndex: 2,
    blurb: 'They shot the opening on Fifth Avenue at 5 a.m. — the only time the street was empty enough.',
    source: 'curated',
  },
  {
    id: 'c-cf-10',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'In Lawrence of Arabia, Peter O\'Toole rides into the desert on a:',
    options: ['Horse', 'Camel', 'Jeep', 'Motorbike'],
    correctIndex: 1,
    blurb: 'O\'Toole said he learned more about pain on those camels than from any acting class.',
    source: 'curated',
  },
  {
    id: 'c-cf-11',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Frankly, in 1939, who did Rhett Butler say he didn\'t give a damn about?',
    options: ['Scarlett', 'Bonnie', 'Mammy', 'The audience'],
    correctIndex: 0,
    blurb: 'Hays Code or no Hays Code — the line stayed in, and history was made.',
    source: 'curated',
  },
  {
    id: 'c-cf-12',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Charlton Heston starred in which 1959 chariot-race epic?',
    options: ['Spartacus', 'Cleopatra', 'Ben-Hur', 'The Robe'],
    correctIndex: 2,
    blurb: 'The chariot race took 78 days to shoot — about a third of the entire production.',
    source: 'curated',
  },
  {
    id: 'c-cf-13',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Who played the lovable scarecrow in The Wizard of Oz?',
    options: ['Bert Lahr', 'Ray Bolger', 'Jack Haley', 'Frank Morgan'],
    correctIndex: 1,
    blurb: 'Bolger had to repaint his face every couple of days — the makeup actually scarred him.',
    source: 'curated',
  },
  {
    id: 'c-cf-14',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Julie Andrews flew in with an umbrella in which 1964 Disney musical?',
    options: ['The Sound of Music', 'Mary Poppins', 'Bedknobs and Broomsticks', 'Chitty Chitty Bang Bang'],
    correctIndex: 1,
    blurb: 'Andrews was 28 and had never made a film before — she won the Oscar for it.',
    source: 'curated',
  },
  {
    id: 'c-cf-15',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'James Dean starred in which 1955 film about a troubled teenager?',
    options: ['Giant', 'East of Eden', 'Rebel Without a Cause', 'On the Waterfront'],
    correctIndex: 2,
    blurb: 'Released the month after he died — the auditorium audiences were silent at the credits.',
    source: 'curated',
  },
  {
    id: 'c-cf-16',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Jaws was directed by which then-young filmmaker?',
    options: ['George Lucas', 'Steven Spielberg', 'Martin Scorsese', 'Francis Ford Coppola'],
    correctIndex: 1,
    blurb: 'Spielberg was 27 — the broken mechanical shark forced him to imply, not show, which improved the film.',
    source: 'curated',
  },
  {
    id: 'c-cf-17',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'In It\'s a Wonderful Life, what is George Bailey\'s guardian angel called?',
    options: ['Gabriel', 'Clarence', 'Bartholomew', 'Michael'],
    correctIndex: 1,
    blurb: 'Henry Travers played him — and earned his wings in viewers\' hearts for 75 years and counting.',
    source: 'curated',
  },
  {
    id: 'c-cf-18',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'West Side Story (1961) updates which Shakespeare tragedy to 1950s New York?',
    options: ['Hamlet', 'Othello', 'Romeo and Juliet', 'Macbeth'],
    correctIndex: 2,
    blurb: 'Stephen Sondheim wrote the lyrics; Leonard Bernstein wrote the score. Some pairing.',
    source: 'curated',
  },
  {
    id: 'c-cf-19',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Star Wars (1977) was created and directed by:',
    options: ['Steven Spielberg', 'Stanley Kubrick', 'George Lucas', 'Ridley Scott'],
    correctIndex: 2,
    blurb: 'The studios passed on it repeatedly. Lucas took back-end profit instead of salary — and never looked back.',
    source: 'curated',
  },
  {
    id: 'c-cf-20',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Cary Grant and Eva Marie Saint ran across which monument in North by Northwest?',
    options: ['The Empire State Building', 'Mount Rushmore', 'The Statue of Liberty', 'The Hollywood Sign'],
    correctIndex: 1,
    blurb: 'Hitchcock had to use a soundstage for most of it — the actual monument said no.',
    source: 'curated',
  },
  {
    id: 'c-cf-21',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Paul Newman and Robert Redford robbed trains in which 1969 film?',
    options: ['Bonnie and Clyde', 'Butch Cassidy and the Sundance Kid', 'The Sting', 'Cool Hand Luke'],
    correctIndex: 1,
    blurb: 'Both leads insisted on doing their own cliff jump. The studio nearly fainted.',
    source: 'curated',
  },
  {
    id: 'c-cf-22',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Barbra Streisand played a brassy comedian named Fanny in which 1968 film?',
    options: ['Hello, Dolly!', 'Funny Girl', 'On a Clear Day', 'The Way We Were'],
    correctIndex: 1,
    blurb: 'Her film debut. She won the Oscar in a tie with Katharine Hepburn — only time it\'s happened.',
    source: 'curated',
  },
  {
    id: 'c-cf-23',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Clint Eastwood\'s "Man with No Name" trilogy was directed by which Italian filmmaker?',
    options: ['Federico Fellini', 'Sergio Leone', 'Vittorio De Sica', 'Roberto Rossellini'],
    correctIndex: 1,
    blurb: 'Spaghetti westerns — shot in Spain, scored by Morricone, and made Eastwood a star.',
    source: 'curated',
  },
  {
    id: 'c-cf-24',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'John Wayne won his only Oscar for which 1969 western?',
    options: ['The Searchers', 'True Grit', 'Stagecoach', 'Rio Bravo'],
    correctIndex: 1,
    blurb: 'He played a one-eyed marshal — and reportedly drank an eyeful before every take.',
    source: 'curated',
  },
  {
    id: 'c-cf-25',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Doctor Zhivago (1965) is set during which historical upheaval?',
    options: ['The French Revolution', 'The Russian Revolution', 'The Spanish Civil War', 'World War II'],
    correctIndex: 1,
    blurb: 'Shot mostly in Spain — they built a snowy Moscow on a sound-stage near Madrid.',
    source: 'curated',
  },
  {
    id: 'c-cf-26',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Some Like It Hot (1959) stars Marilyn Monroe and which two men in drag?',
    options: [
      'Jack Lemmon and Walter Matthau',
      'Tony Curtis and Jack Lemmon',
      'Cary Grant and James Stewart',
      'Bob Hope and Bing Crosby',
    ],
    correctIndex: 1,
    blurb: 'Monroe needed dozens of takes for some scenes — but every one she nailed was magic.',
    source: 'curated',
  },
  {
    id: 'c-cf-27',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Which 1939 film follows a girl, a tin man, a scarecrow, and a lion?',
    options: ['Pinocchio', 'The Wizard of Oz', 'Bambi', 'Fantasia'],
    correctIndex: 1,
    blurb: 'They almost cast Shirley Temple as Dorothy. Imagine.',
    source: 'curated',
  },
  {
    id: 'c-cf-28',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Jimmy Stewart played a small-town lawyer defending in which Otto Preminger courtroom drama?',
    options: ['Anatomy of a Murder', 'Witness for the Prosecution', '12 Angry Men', 'Inherit the Wind'],
    correctIndex: 0,
    blurb: 'Released in 1959 — used candid courtroom language no Hollywood film had dared.',
    source: 'curated',
  },
  {
    id: 'c-cf-29',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Rocky (1976) was written by and starred which underdog actor?',
    options: ['Burt Reynolds', 'Sylvester Stallone', 'Al Pacino', 'Robert De Niro'],
    correctIndex: 1,
    blurb: 'Stallone wrote it in three days — and refused to sell unless they let him star.',
    source: 'curated',
  },
  {
    id: 'c-cf-30',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'My Fair Lady (1964) is based on which George Bernard Shaw play?',
    options: ['Pygmalion', 'Heartbreak House', 'Major Barbara', 'Saint Joan'],
    correctIndex: 0,
    blurb: 'Audrey Hepburn took the film role; the studio dubbed her singing — Marni Nixon did the singing.',
    source: 'curated',
  },
  {
    id: 'c-cf-31',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Sidney Poitier became the first Black actor to win Best Actor for which 1963 film?',
    options: [
      'In the Heat of the Night',
      'Lilies of the Field',
      'Guess Who\'s Coming to Dinner',
      'A Patch of Blue',
    ],
    correctIndex: 1,
    blurb: 'He played a wandering handyman who builds a chapel for German nuns in the Arizona desert.',
    source: 'curated',
  },
  {
    id: 'c-cf-32',
    category: 'Classic Films',
    categorySlug: 'classic-films',
    prompt: 'Mary Poppins\' chimney sweep, played by Dick Van Dyke, was named:',
    options: ['Bert', 'Albert', 'Herbert', 'Gilbert'],
    correctIndex: 0,
    blurb: 'Van Dyke\'s cockney accent is still considered one of the worst attempts on film — and we love him for it.',
    source: 'curated',
  },
];
